import React, { useState } from "react";
import { Box } from "@mui/material";
import PersonalInformationForm from "./profile";
import EducationForm from "./education";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";

import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import ExperienceDetailsForm from "./experience";
import ProjectsForm from "./projects";
import AchievementsForm from "./acheive";
import CertificationsForm from "./certifications";
import Alert from "@mui/material/Alert";
import LanguagesForm from "./language";
import HobbiesForm from "./interest";
import AvailabilityForm from "./availability";
import SalaryExpectationsForm from "./salary";
import SelfIdentificationForm from "./selfidentification";
import LegalAuthorizationForm from "./legalauthorize";
import WorkPreferencesForm from "./workpreference";
import { toast } from "react-toastify";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

import UserForm from "./App";
const pages = ["Resume File","Config File","Report Bug"];



const Home = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [option,setoption]= React.useState(0)

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (data) => {
    setAnchorElNav(null);
    if(data === 0 || data ===1)
    {
      setoption(data)
    }
    else{
      handleClickOpen()
    }
    
    
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
   
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [profileData, setProfileData] = useState(null);
  const handleProfileChange = (data) => {
    setProfileData(data);
  };
  const [eduData, setEduData] = useState(null);

  const handleEduChange = (data) => {
    setEduData(data);
    console.log(eduData);
  };
  const [expData, setExpData] = useState(null);

  const handleExperience = (data) => {
    setExpData(data);
    console.log(data);
  };

  const [projData, setProjData] = useState(null);

  const handleProj = (data) => {
    setProjData(data);
    console.log(data);
  };
  const [achData, setAchData] = useState(null);

  const handleAch = (data) => {
    setAchData(data);
    console.log(data);
  };

  const [certData, setCertData] = useState(null);
  const handleCert = (data) => {
    setCertData(data);
    console.log(data);
  };

  const [langData, setLangData] = useState(null);
  const handleLang = (data) => {
    setLangData(data);
    console.log(data);
  };
  const [interestData, setInterestData] = useState(null);
  const handleInterest = (data) => {
    setInterestData(data);
    console.log(data);
  };

  const [availData, setAvailData] = useState(null);
  const handleAvail = (data) => {
    setAvailData(data);
    console.log(data);
  };

  const [salaryData, setSalaryData] = useState(null);
  const handleSalary = (data) => {
    setSalaryData(data);
    console.log(data);
  };

  const [sidenData, setSidenData] = useState(null);
  const handleSiden = (data) => {
    setSidenData(data);
    console.log(data);
  };

  const [legalauthData, setLegalAuthData] = useState(null);
  const handleLegalAuth = (data) => {
    setLegalAuthData(data);
    console.log(data);
  };

  const [workPrefData, setWorkPrefData] = useState(null);
  const handleWorkPref = (data) => {
    setWorkPrefData(data);
    console.log(data);
  };

  const highlightKey = (key) => {
    // Check if the key is "personal_information" and apply a different color
    if (
      key === "personal_information" ||
      key === "edu_information" ||
      key === "experience_details" ||
      key === "projects" ||
      key === "achievements" ||
      key === "certifications" ||
      key === "languages" ||
      key === "interests" ||
      key === "availability" ||
      key === "salary_expectations" ||
      key === "self_identifications" ||
      key === "legal_authorization" ||
      key === "work_preferences"
    ) {
      return <span style={{ color: "blue" }}>{key}</span>;
    }

    // Apply a different color for other keys
    return <span style={{ color: "green" }}>{key}</span>;
  };
  const generateFile = () => {
   
    
    

    if (
      !profileData ||
      profileData?.length === 0 ||
      !eduData ||
      eduData?.length === 0 ||
      !expData ||
      expData?.length === 0 ||
      !projData ||
      projData?.length === 0 ||
      !achData ||
      achData?.length === 0 ||
      !certData ||
      certData?.length === 0 ||
      !langData ||
      langData?.length === 0 ||
      !interestData ||
      interestData?.length === 0 ||
      !availData ||
      availData?.length === 0 ||
      !salaryData ||
      salaryData?.length === 0 ||
      !sidenData ||
      sidenData?.length === 0 ||
      !legalauthData ||
      legalauthData?.length === 0 ||
      !workPrefData ||
      workPrefData?.length === 0
    ) {
      toast.error("Please See Warnings", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else{

         //prepare yml data
    
    const formPD= formatPersonalInfo(profileData?.personal_information);
    const formEdu = formatEducationDetails(eduData?.edu_information)
    const formExp= formatExpDetails(expData?.experience_details);
    const formProj= formatProjDetails(projData?.projects);
    const formAch= formatAchDetails(achData?.achievements);
    const formCert= formatCertDetails(certData?.certifications);
    const formLang= formatLangDetails(langData?.languages);
    const formInterest= formatInterDetails(interestData?.interests);
    const formAvail =formatAvailDetails(availData?.availability);
    const formSal = formatSalDetails(salaryData?.salary_expectations);
    const formSI = formatSelfDetails(sidenData);
    const formLA = formatLADetails(legalauthData?.legal_authorization)
    const formWP = formatWPDetails(workPrefData?.work_preferences);
   
   const textContent = `${formPD}\n\n${formEdu}\n\n${formExp}\n\n${formProj}\n\n${formAch}\n\n${formCert}\n\n${formLang}\n\n${formInterest}\n\n${formAvail}\n\n${formSal}\n\n${formSI}\n\n${formLA}\n\n${formWP}`
    // Create a Blob from the text content
    const blob = new Blob([textContent], { type: 'text/plain' });
    
    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);
    
    // Create a link element
    const a = document.createElement('a');
    a.href = url;
    a.download = 'resume.yml'; // Set the filename for the download
    
    // Append link to the body, click it and remove it
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    
    // Revoke the object URL
    URL.revokeObjectURL(url);
    }
   
    
    
  };
  const formatPersonalInfo = (personalInfo) => {
    let output = "personal_information:\n";
    Object.entries(personalInfo).forEach(([key, value]) => {
      output += `  ${key}: "${value}"\n`;
    });
    return output;
  };
  const formatEducationDetails = (eduInfo) => {
    let output = "education_details:\n";
    eduInfo.forEach((edu, index) => {
      output += `  - degree: "${edu.degree}"\n`;
      output += `    university: "${edu.university}"\n`;
      output += `    gpa: "${edu.gpa}"\n`;
      output += `    graduation_year: "${edu.graduation_year}"\n`;
      output += `    field_of_study: "${edu.field_of_study}"\n`;
      output += "    exam:\n";
      edu.exams.forEach((exam) => {
        output += `      ${exam.name}: "${exam.grade}"\n`;
      });
      if (index < eduInfo.length - 1) {
        output += "\n";
      }
    });
    return output;
  };
  const formatExpDetails = (expInfo) => {
    const formattedOutput = `experience_details:\n${expInfo
      .map(
        (exp) =>
          `  - position: "${exp.position}"\n    company: "${
            exp.company
          }"\n    employment_period: "${exp.start_date} - ${
            exp.end_date
          }"\n    location: "${exp.location}"\n    industry: "${
            exp.industry
          }"\n    key_responsibilities:\n      - ${exp.key_responsibilities
            .map((res) => `"${res}"`)
            .join(
              "\n      - "
            )}\n    skills_acquired:\n      - ${exp.skills_acquired
            .map((skill) => `"${skill}"`)
            .join("\n      - ")}`
      )
      .join("\n")}`;
    return formattedOutput;
  };
  const formatProjDetails = (projInfo) => {
    const output = `projects:\n${projInfo
      .map(
        (proj) =>
          `  - name: "${proj.name}"\n    description: "${proj.description}"\n    link: "${proj.link}"`
      )
      .join("\n")}`;
    return output;
  };

  const formatAchDetails = (achInfo) => {
    const output = `achievements:\n${achInfo
      .map(
        (ach) =>
          `  - name: "${ach.name}"\n    description: "${ach.description}"`
      )
      .join("\n")}`;
    return output;
  };
  const formatCertDetails = (certInfo) => {
    const output = `certifications:\n${certInfo
      .map((cert) => `  - "${cert}"`)
      .join("\n")}`;
    return output;
  };
  const formatLangDetails = (langInfo) => {
    const output = `languages:\n${langInfo
      .map(
        (lang) =>
          `  - language: "${lang.language}"\n    proficiency: "${lang.proficiency}"`
      )
      .join("\n")}`;
    return output;
  };
  const formatInterDetails = (interInfo) => {
    const output = `interests:\n  - ${interInfo
      .map((hobby) => `"${hobby}"`)
      .join("\n  - ")}`;
    return output;
  };
  const formatAvailDetails = (availInfo) => {
    const output = `availability:\n  notice_period: "${availInfo}"`;
    return output;
  };

  const formatSalDetails = (salInfo) => {
    const output = `salary_expectations:\n  salary_range_usd: "${salInfo}"`;
    return output;
  };
  const formatSelfDetails = (selfInfo) => {
    const output = `self_identification:\n  gender: "${selfInfo?.self_identifications?.gender}"\n  pronouns: "${selfInfo?.self_identifications?.pronouns}"\n  veteran: "${selfInfo?.self_identifications?.veteran}"\n  disability: "${selfInfo?.self_identifications?.disability}"\n  ethnicity: "${selfInfo?.self_identifications?.ethnicity}"`;
    return output;
  };
  const formatLADetails =(laInfo)=>{
    const output = `legal_authorization:\n  eu_work_authorization: "${laInfo.eu_work_authorization}"\n  us_work_authorization: "${laInfo.us_work_authorization}"\n  requires_us_visa: "${laInfo.requires_us_visa}"\n  requires_us_sponsorship: "${laInfo.requires_us_sponsorship}"\n  requires_eu_visa: "${laInfo.requires_eu_visa}"\n  legally_allowed_to_work_in_eu: "${laInfo.legally_allowed_to_work_in_eu}"\n  legally_allowed_to_work_in_us: "${laInfo.legally_allowed_to_work_in_us}"\n  requires_eu_sponsorship: "${laInfo.requires_eu_sponsorship}"`;
    return output
  }
  const formatWPDetails =(wpInfo)=>{
    const output = `work_preferences:\n  remote_work: "${wpInfo.remote_work}"\n  in_person_work: "${wpInfo.in_person_work}"\n  open_to_relocation: "${wpInfo.open_to_relocation}"\n  willing_to_complete_assessments: "${wpInfo.willing_to_complete_assessments}"\n  willing_to_undergo_drug_tests: "${wpInfo.willing_to_undergo_drug_tests}"\n  willing_to_undergo_background_checks: "${wpInfo.willing_to_undergo_background_checks}"`;
    return output
  }
  return (
    <div>
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} />
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "#fff !important",
                textDecoration: "none",
              }}
            >
              HAUK-EASE
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: "block", md: "none" } }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography sx={{ textAlign: "center" }}>{page}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} />
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "#fff !important",
                textDecoration: "none",
              }}
            >
              HAUK-EASE
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              {pages.map((page,index) => (
                <Button
                  key={page}
                  onClick={ ()=>handleCloseNavMenu(index)}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  {page}
                </Button>
              ))}
            </Box>
           
          </Toolbar>
          <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Report Bug/Contact Me"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <Button variant="contained" startIcon={<LinkedInIcon />}>
        <a href="https://www.linkedin.com/in/eitzaz-haider-bb471b194/" style={{textDecoration:'none',color:'#fff'}}>Linkedin</a>
      </Button><br></br><br></br>
      <Button variant="contained" startIcon={<InstagramIcon />}>
      <a href="https://www.instagram.com/mr_shxh_151/" style={{textDecoration:'none',color:'#fff'}}>Instagram</a>
      </Button>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
         
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
        </Container>
      </AppBar>
              {
                option ===0?
                ( <Box  sx={{
       
                  display: {
                    sm: 'block',  // Block display for mobile
                    md: 'flex',    // Flex display for medium screens and up
                  }
                }}>
                  <Box component="form" sx={{ p: 1,  width: {
                    xs: '100%',   // 100% width on mobile
                    sm: '50%',    // 100% width on small screens and up
                  },height:'700px',overflowY:'scroll'}}>
                    <PersonalInformationForm
                      onChildData={handleProfileChange}
                    ></PersonalInformationForm>
                    <EducationForm onChildData={handleEduChange}></EducationForm>
                    <ExperienceDetailsForm
                      onChildData={handleExperience}
                    ></ExperienceDetailsForm>
                    <ProjectsForm onChildData={handleProj}></ProjectsForm>
                    <AchievementsForm onChildData={handleAch}></AchievementsForm>
                    <CertificationsForm onChildData={handleCert}></CertificationsForm>
                    <LanguagesForm onChildData={handleLang}></LanguagesForm>
                    <HobbiesForm onChildData={handleInterest}></HobbiesForm>
                    <AvailabilityForm onChildData={handleAvail}></AvailabilityForm>
                    <SalaryExpectationsForm
                      onChildData={handleSalary}
                    ></SalaryExpectationsForm>
                    <SelfIdentificationForm
                      onChildData={handleSiden}
                    ></SelfIdentificationForm>
                    <LegalAuthorizationForm
                      onChildData={handleLegalAuth}
                    ></LegalAuthorizationForm>
                    <WorkPreferencesForm
                      onChildData={handleWorkPref}
                    ></WorkPreferencesForm>
                    <Box component="form" sx={{ p: 3, pt: 0, pb: 2 }}>
                      <Button variant="contained" onClick={generateFile}>
                        Submit
                      </Button>
                    </Box>
                  </Box>
                  <Box sx={{ p: 1,  width: {
                    xs: '100%',   // 100% width on mobile
                    sm: '50%',    // 100% width on small screens and up
                  },mt:2 }}>
                    <pre>
                      {profileData ? (
                        Object.entries(profileData).map(([parentKey, parentValue]) => (
                          <div key={parentKey}>
                            {highlightKey(parentKey)}:
                            {Object.entries(parentValue).map(([key, value]) => (
                              <div key={key}>
                                &nbsp;&nbsp;{highlightKey(key)}: {value}
                              </div>
                            ))}
                          </div>
                        ))
                      ) : (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no personal details available
                        </Alert>
                      )}
                    </pre>
                    <pre>
                      {eduData ? <span>{highlightKey("edu_information")}:</span> : ""}
                      {eduData ? (
                        eduData.edu_information.map((eduInfo, index) => (
                          <div key={index}>
                            {Object.entries(eduInfo).map(([key, value]) => (
                              <div key={key}>
                                &nbsp;&nbsp;{highlightKey(key)}:{" "}
                                {Array.isArray(value)
                                  ? value.map((exam, examIndex) => (
                                      <div key={examIndex}>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        {Object.entries(exam).map(
                                          ([examKey, examValue]) => (
                                            <div key={examKey}>
                                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                              {highlightKey(examKey)}: {examValue}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    ))
                                  : value}
                                <br></br>
                              </div>
                            ))}
                          </div>
                        ))
                      ) : (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no education details available
                        </Alert>
                      )}
                    </pre>
                    <pre>
                      {expData ? <span>{highlightKey("experience_details")}:</span> : ""}
                      {expData ? (
                        expData.experience_details.map((eduInfo, index) => (
                          <div key={index}>
                            {Object.entries(eduInfo).map(([key, value]) => (
                              <div key={key}>
                                &nbsp;&nbsp;{highlightKey(key)}:{" "}
                                {Array.isArray(value) ? (
                                  <div>
                                    {value.map((item, itemIndex) => (
                                      <div key={itemIndex}>
                                        &nbsp;&nbsp;&nbsp;&nbsp;{item}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  value
                                )}
                                <br></br>
                              </div>
                            ))}
                          </div>
                        ))
                      ) : (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no experience details available
                        </Alert>
                      )}
                    </pre>
          
                    <pre>
                      {projData && (
                        <div>
                          {projData?.projects.length === 0 ? (
                            ""
                          ) : (
                            <span>{highlightKey("projects")}:</span>
                          )}
          
                          {projData.projects.map((eduInfo, index) => (
                            <div key={index}>
                              {Object.entries(eduInfo).map(([key, value]) => (
                                <div key={key}>
                                  &nbsp;&nbsp;{highlightKey(key)}: {value}
                                </div>
                              ))}
                              <br></br>
                            </div>
                          ))}
                        </div>
                      )}
                      {!projData || projData.projects.length === 0 ? (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no projects available
                        </Alert>
                      ) : (
                        ""
                      )}
                    </pre>
          
                    <pre>
                      {achData && (
                        <div>
                          {achData?.achievements.length === 0 ? (
                            ""
                          ) : (
                            <span>{highlightKey("achievements")}:</span>
                          )}
          
                          {achData.achievements.map((eduInfo, index) => (
                            <div key={index}>
                              {Object.entries(eduInfo).map(([key, value]) => (
                                <div key={key}>
                                  &nbsp;&nbsp;{highlightKey(key)}: {value}
                                </div>
                              ))}
                              <br></br>
                            </div>
                          ))}
                        </div>
                      )}
                      {!achData || achData.achievements.length === 0 ? (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no achievements available
                        </Alert>
                      ) : (
                        ""
                      )}
                    </pre>
          
                    <pre>
                      {certData && (
                        <div>
                          {certData?.certifications.length === 0 ? (
                            ""
                          ) : (
                            <span>{highlightKey("certifications")}:</span>
                          )}
          
                          {certData?.certifications.map((eduInfo, index) => (
                            <div key={index}>
                              &nbsp;&nbsp;{highlightKey(eduInfo)}
                              <br></br>
                            </div>
                          ))}
                        </div>
                      )}
          
                      {!certData || certData.certifications.length === 0 ? (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no certifications available.
                        </Alert>
                      ) : (
                        ""
                      )}
                    </pre>
          
                    <pre>
                      {langData && (
                        <div>
                          {langData?.languages.length === 0 ? (
                            ""
                          ) : (
                            <span>{highlightKey("languages")}:</span>
                          )}
          
                          {langData.languages.map((eduInfo, index) => (
                            <div key={index}>
                              {Object.entries(eduInfo).map(([key, value]) => (
                                <div key={key}>
                                  &nbsp;&nbsp;{highlightKey(key)}: {value}
                                </div>
                              ))}
                              <br></br>
                            </div>
                          ))}
                        </div>
                      )}
                      {!langData || langData.languages.length === 0 ? (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no languages available
                        </Alert>
                      ) : (
                        ""
                      )}
                    </pre>
          
                    <pre>
                      {interestData && (
                        <div>
                          {interestData?.interests.length === 0 ? (
                            ""
                          ) : (
                            <span>{highlightKey("interests")}:</span>
                          )}
          
                          {interestData?.interests.map((eduInfo, index) => (
                            <div key={index}>
                              &nbsp;&nbsp;{highlightKey(eduInfo)}
                              <br></br>
                            </div>
                          ))}
                        </div>
                      )}
          
                      {!interestData || interestData?.interests.length === 0 ? (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no interests available.
                        </Alert>
                      ) : (
                        ""
                      )}
                    </pre>
          
                    <pre>
                      {availData && (
                        <div>
                          {availData?.availability.length === 0 ? (
                            ""
                          ) : (
                            <span>{highlightKey("availability")}:</span>
                          )}
                          <div>
                            &nbsp;&nbsp;{highlightKey(availData?.availability)}
                            <br></br>
                          </div>
                        </div>
                      )}
                      {!availData || availData?.availability.length === 0 ? (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no availability available.
                        </Alert>
                      ) : (
                        ""
                      )}
                    </pre>
          
                    <pre>
                      {salaryData && (
                        <div>
                          {salaryData?.salary_expectations.length === 0 ? (
                            ""
                          ) : (
                            <span>{highlightKey("salary_expectations")}:</span>
                          )}
                          <div>
                            &nbsp;&nbsp;{highlightKey(salaryData?.salary_expectations)}
                            <br></br>
                          </div>
                        </div>
                      )}
                      {!salaryData || salaryData?.salary_expectations.length === 0 ? (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no salary expectation available.
                        </Alert>
                      ) : (
                        ""
                      )}
                    </pre>
          
                    <pre>
                      {sidenData ? (
                        Object.entries(sidenData).map(([parentKey, parentValue]) => (
                          <div key={parentKey}>
                            {highlightKey(parentKey)}:
                            {Object.entries(parentValue).map(([key, value]) => (
                              <div key={key}>
                                &nbsp;&nbsp;{highlightKey(key)}: {value}
                              </div>
                            ))}
                          </div>
                        ))
                      ) : (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no side identification details available
                        </Alert>
                      )}
                    </pre>
          
                    <pre>
                      {legalauthData ? (
                        Object.entries(legalauthData).map(([parentKey, parentValue]) => (
                          <div key={parentKey}>
                            {highlightKey(parentKey)}:
                            {Object.entries(parentValue).map(([key, value]) => (
                              <div key={key}>
                                &nbsp;&nbsp;{highlightKey(key)}: {value}
                              </div>
                            ))}
                          </div>
                        ))
                      ) : (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no legal authorization details available
                        </Alert>
                      )}
                    </pre>
          
                    <pre>
                      {workPrefData ? (
                        Object.entries(workPrefData).map(([parentKey, parentValue]) => (
                          <div key={parentKey}>
                            {highlightKey(parentKey)}:
                            {Object.entries(parentValue).map(([key, value]) => (
                              <div key={key}>
                                &nbsp;&nbsp;{highlightKey(key)}: {value}
                              </div>
                            ))}
                          </div>
                        ))
                      ) : (
                        <Alert severity="warning" sx={{ textTransform: "capitalize" }}>
                          no work preferences details available
                        </Alert>
                      )}
                    </pre>
                  </Box>
                </Box>):<UserForm></UserForm>

              }
     <div style={{textAlign:'center',padding:'15px'}}><Typography variant="caption">@ All rights reserved by <a href="https://www.linkedin.com/in/eitzaz-haider-bb471b194/">Syed Eitzaz</a></Typography></div>
     
    </div>
  );
};

export default Home;
